import {
  NavLink,
} from 'react-router';

import {
  Flex,
} from 'web-styled';

import {
  Tooltip,
} from 'web-components';

import {
  OpenedTooltip,
} from 'web-types';

import * as S from './styled';

interface Tab {
  to: string;
  name: string;
  unread?: boolean;
}

interface Props {
  tabs?: Array<Tab>;
  openedTooltips?: OpenedTooltip[],
  onRemoveTooltip?: { (): void };
}

/**
 * Navigation Tabs
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](ubayd.rahmonzoda@gmail.com)
 */
const NavigationTabs = ({
  tabs = [],
  openedTooltips = [],
  onRemoveTooltip,
}: Props) => (
  <Flex spacing={15} noPrint>
    {tabs?.map(tab => (tab.name === 'assign' && openedTooltips?.some(el => el.key === 'assign')
      ? (
        <Tooltip
          toggleMode
          initialState
          body="Click Assign"
          positions={['left']}
          key={tab.to}
        >
          <S.LinkWrapper>
            <NavLink
              end
              to={tab.to}
              onClick={onRemoveTooltip}
            >
              {tab.name}
            </NavLink>
          </S.LinkWrapper>
        </Tooltip>
      ) : (
        <S.LinkWrapper key={tab.to}>
          <NavLink
            end
            to={tab.to}
          >
            {tab.name}
            {tab.unread && <S.Unread />}
          </NavLink>
        </S.LinkWrapper>
      )))}
  </Flex>
);

export default NavigationTabs;
